// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-empresas-js": () => import("/opt/build/repo/src/pages/empresas.js" /* webpackChunkName: "component---src-pages-empresas-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-portfolio-js": () => import("/opt/build/repo/src/pages/portfolio.js" /* webpackChunkName: "component---src-pages-portfolio-js" */),
  "component---src-pages-sobre-js": () => import("/opt/build/repo/src/pages/sobre.js" /* webpackChunkName: "component---src-pages-sobre-js" */),
  "component---src-pages-teste-js": () => import("/opt/build/repo/src/pages/teste.js" /* webpackChunkName: "component---src-pages-teste-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

